module.exports = __webpack_public_path__ + "static/media/slide-4.2a7d68be.jpg";